var _rect, _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 13,
    y: 13,
    width: 22,
    height: 22,
    fill: "url(#pattern0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 24,
    cy: 24,
    r: 23.25,
    stroke: "#FAFAF5",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABkklEQVRIDb2VgVHDMAxFO0JH6AiMwAjdgI7ACGwAG8AGdAPYADZoN4ANPvdT/cNVYls2MbrrKWlsPVm2vjebDgNwA+BE3zG9b4pBv3Ax+vFwBzU2xsIBbAF8iOb8GHgFqhzWhQeh68MBfCpq0B/7jq2bBeA7COQwJrl1IeKvVt49ZwA4BsGE7gDcAXgG8NqUhNvTA4D7IJiC4o1dUK+AgypIDcytOGvwgi/DM1DGYZvkjNDb3Mfk/zwcwEsycOnx3cZodYRSs/dLgxf+m8MDUMU52IEjcGfPT/oY8L/wBqjiXl0KAFiJFrvAO8DntDGt3H293giflMl6dlp9A3wuMA1wtheFQqednmLxWKn3HKrSBXWZ7cN9yplOffo9D7UTyjuXg0pWgnLeg9P3MjRZdQ5eS0jJsr3YbjxwMaiD83Lgj3rNQG+KXPEnqx7n1HVaUO8LUlriT+LiYzW9N5x2JcIS969U2dmKo/s76bfm/tkH4etClXUFPgaawKlYhKQ2FprA1aOE/w/UwSmNV1ekvkf8D13GL0WUteU1AAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.47d440f4.svg";
export { ForwardRef as ReactComponent };